import { FC } from 'react';
import { createPortal } from 'react-dom';

const WRAPPER_ID = 'modal-wrapper';

export const ReactPortal: FC = ({ children }) => {
  const wrapperElement =
    document.getElementById(WRAPPER_ID) || createWrapperElement(WRAPPER_ID);

  // Let's ignore first render, as element won't be ready at this stage
  if (!wrapperElement) {
    return null;
  }

  return createPortal(children, wrapperElement);
};

function createWrapperElement(elementId: string) {
  const wrapperElement = document.createElement('div');
  wrapperElement.setAttribute('id', elementId);
  document.body.appendChild(wrapperElement);

  return wrapperElement;
}
